module.exports = __webpack_public_path__ + "img/native-form.2f3be43.png";